import { c as _c } from "react/compiler-runtime";
import levels from "@/constants/levels.json";
interface LevelData {
  level: number;
  threshold: number;
}
export default function TableOfLevels() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <caption id="levels-caption" className="tw-sr-only">Thresholds by Level</caption>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <thead className="tw-sticky tw-top-0 tw-z-10 tw-bg-iron-700"><tr><td className="uppercase tw-py-3 tw-pl-4 tw-pr-3 tw-text-left tw-text-xs tw-font-semibold tw-text-white sm:tw-pl-6">Level</td><td className="uppercase tw-py-3 tw-pl-4 tw-pr-3 tw-text-left tw-text-xs tw-font-semibold tw-text-white sm:tw-pl-6">TDH + Rep</td></tr></thead>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center"><div className="tw-w-full tw-overflow-x-auto tw-rounded-lg tw-ring-1 tw-ring-white/[0.15] xl:tw-max-w-4xl"><table className="tw-min-w-full tw-divide-y tw-divide-iron-700/60" aria-labelledby="levels-caption">{t0}{t1}<tbody className="tw-divide-y tw-divide-iron-700/60 tw-bg-[#222222]">{(levels as LevelData[]).map(_temp)}</tbody></table></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(level) {
  return <tr key={`level-${level.level}`} className="tw-transition tw-duration-300 tw-ease-out odd:tw-bg-iron-800/40 hover:tw-bg-iron-700/40"><td className="tw-whitespace-nowrap tw-py-3 tw-pl-4 tw-pr-3 tw-text-sm tw-font-medium tw-text-iron-300 sm:tw-pl-6">{level.level}</td><td className="tw-whitespace-nowrap tw-py-3 tw-pl-4 tw-pr-3 tw-text-sm tw-font-medium tw-text-iron-300 sm:tw-pl-6">{level.threshold.toLocaleString()}</td></tr>;
}